<template>
  <div class="about" ref="about">
    <!-- 关于我们 -->
    <div class="nav_box">
      <Nav :isClass="isClass" :active="5"></Nav>
    </div>
    <div class="banner">
      <div class="banner_title">一站式算力交易和服务平台</div>
      <div class="banner_new">实现对通用算力、超算算力、人工智能算力的统一管理、统一服务和统一运营</div>
    </div>
    <div class="content_box">
      <div class="bg">
        <div class="introduce">
          <div class="introduce_title">公司简介</div>
          <div class="introduce_content">Company Profile</div>
        </div>
        <div class="brief">
          <img src="../assets/img/位图@2x (19).png">
          <div class="brief_content">
            金华数据局在算力方面积极推动全市算力资源的统筹和整合，致力于打造算网一体化，抓住国家“东数西算”布局的机遇，抢先配置区域算力资源，全力打造区域算力枢纽中心和公共算力服务平台。基于算力互联网的新兴技术概念，结合当前算力服务网络的发展趋势，金华数据局统筹规划布局区域算力基础设施，设立面向区域的算力云网运营主体，提供数据中心与全生命周期安全服务、云资源服务、算力资源服务、存储资源服务、数据资源服务、算网通信资源服务、算网平台生态服务以及其他配套增值服务。金华数据局定位发展成为全国算力网络重要的枢纽节点和金华市域公共算力服务平台，为数字金华的高质量发展提供坚实的基础保障。
          </div>
        </div>
      </div>
    </div>
    <div class="map_box">
      <div class="title">
        <div class="introduce_title">联系我们</div>
        <div class="introduce_content">contact us</div>
      </div>
      <div class="area_map_box">
        <div class="area_left">
          <!-- <div class="area_item">
            <img src="../assets/img/矩形@2x (1).png">
            <div class="arer_item_address">
              <div class="address_title">办公地址</div>
              <div class="address_item">金华市婺城区宾虹西路2558号（大数据发展管理局）</div>
            </div>
          </div> -->
          <div class="area_top_box">
            <div class="title_e">Contact us</div>
            <div class="title_t">联系我们</div>
          </div>
          <div class="phone_box">
            <div class="phone_list">
              <div class="phone_item">电信：15305799692</div>
              <div class="phone_item">联通：15657171815</div>
              <div class="phone_item">移动：13957990939</div>
            </div>
          </div>
          <!-- <div class="area_item">
            <img src="../assets/img/矩形@2x (2).png">
            <div class="arer_item_address">
              <div class="address_title">联系方式</div>
              <div class="address_item">电信：15305799692</div>
              <div class="address_item">联通：15657171815</div>
              <div class="address_item">移动：13957990939</div>
            </div>
          </div> -->
          <!-- <div class="area_item">
            <img src="../assets/img/邮件@2x.png">
            <div class="arer_item_address">
              <div class="address_title">电子邮箱</div>
              <div class="address_item">商务问题请咨询：王经理</div>
              <div class="address_item" style="margin-bottom: 12px;">wangxy@sz-bigdata.suzhou.com.cn</div>
              <div class="address_item">技术问题请咨询：钱工</div>
              <div class="address_item">qianlk@sz-bigdata.suzhou.com.cn</div>
            </div>
          </div> -->
        </div>
        <div class="arer_right_map">
          <div id="baiduMap" style="width: 100%; height: 100%;"></div>
        </div>
      </div>
    </div>
    <div class="section_fort section6">
      <div class="fort_box">
        <div class="foot_title">共建科技算力服务生态</div>
        <div class="foot_btn">立即咨询</div>
      </div>
    </div>
    <!-- <div class="footer_fout"><Clas></Clas></div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClass: false,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    let minWidth = window.screen.width;
    this.$refs["about"].style.minWidth = minWidth + "px";
    window.addEventListener('scroll', this.mouseWheelHandle, true);

    var map = new BMap.Map("baiduMap");
    var point = new BMap.Point(119.580199, 29.090719); // 地图中心点坐标 
    var marker = new BMap.Marker(point);        // 创建标注   
    map.addOverlay(marker);
    // 比例尺
    map.enableScrollWheelZoom(true)
    var scaleCtrl = new BMap.ScaleControl();
    map.addControl(scaleCtrl);
    // 添加地图类型控件（右上角）
    // map.addControl(
    //   new BMap.MapTypeControl()
    // )
    let navigationControl = new BMap.NavigationControl({
      anchor: BMAP_ANCHOR_TOP_RIGHT  // 控件的定位 左上角 还有其他
    }) // 添加默认缩放平移控件
    // var opts = {
    //   width: 250,     // 信息窗口宽度
    //   height: 100,    // 信息窗口高度
    //   title: "Hello"  // 信息窗口标题
    // }
    // var infoWindow = new BMap.InfoWindow("World", opts);  // 创建信息窗口对象
    // map.openInfoWindow(infoWindow, map.getCenter());
    map.addControl(navigationControl)
    map.addControl(new BMap.CityListControl())
    map.centerAndZoom(point, 15);
  },
  methods: {
    mouseWheelHandle() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 400) {
        this.isClass = true
      } else {
        this.isClass = false
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.mouseWheelHandle);
  },
}
</script>

<style lang="scss" scoped>
.nav_box {
  position: fixed;
  // position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
}

.banner {
  width: 100%;
  height: 700px;
  background-image: url("../assets/img/位图@2x (18).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .banner_title {
    text-align: center;
    font-weight: 500;
    font-size: 28px;
    color: #FFFFFF;
    margin-bottom: 20px;
  }

  .banner_new {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.content_box {
  background-color: #EAEEF0;

  .bg {
    width: 100%;
    padding: 50px 0;
    background-image: url("../assets/img/bg2_left.png"), url("../assets/img/bg2_right.png");
    background-repeat: no-repeat;
    background-size: 576px 458px, 576px 458px;
    background-position: left top, right bottom;

    .introduce {
      text-align: center;

      .introduce_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        margin-bottom: 10px;
      }

      .introduce_content {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }

    .brief {
      margin-top: 50px;
      position: relative;
      display: flex;
      justify-content: center;

      img {
        width: 400px;
        height: 273px;
        position: absolute;
        left: 5%;
        top: 14%;
      }

      .brief_content {
        width: 800px;
        height: 372px;
        background-color: #FFFFFF;
        padding: 0 60px;
        padding-left: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        line-height: 35px;
        border-radius: 12px;
        margin-left: 220px;
      }

    }

  }


}

.map_box {
  height: 679px;
  background: #F5F5F5;
  padding: 80px 0;

  .title {
    text-align: center;

    .introduce_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      margin-bottom: 10px;
    }

    .introduce_content {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }

  }

  .area_map_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;

    .area_left {
      width: 300px;
      height: 330px;
      background-color: #FFFFFF;
      padding: 40px;
      border-radius: 6px;
      margin-right: 36px;
      display: flex;
      flex-direction: column;

      // justify-content: space-between;
      .area_top_box {
        border-bottom: 5px solid #0C498E;

        .title_e {
          font-family: Franklin Gothic Demi;
          font-weight: 400;
          font-size: 40px;
          color: #0C498E;
        }

        .title_t {
          font-family: Source Han Sans CN;
          font-weight: 800;
          font-size: 23px;
          color: #0C498E;
          margin: 22px 0 18px 0;
        }
      }

      .phone_box {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .phone_list {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;

          .phone_item {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 20px;
            color: #333333;
          }
        }
      }

      .area_item {
        display: flex;

        img {
          width: 28px;
          height: 28px;
          margin-right: 15px;
        }

        .arer_item_address {
          .address_title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #666666;
            margin-bottom: 10px;
          }

          .address_item {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }

    .arer_right_map {
      width: 800px;
      height: 390px;
      background-color: #eee;
    }
  }
}

.section6 {
  background-image: url("../assets/img/位图@2x(15).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 193px;

  .fort_box {
    width: 1190px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .foot_title {
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
  }

  .foot_btn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 124px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #094990;

    &:hover {
      background-color: #094990;
      color: #FFFFFF;
    }
  }

}

.footer_fout {
  position: fixed;
  bottom: 10%;
  right: 0;
}
</style>